export function startCSVDownload(data, fileName = 'export') {
    if (window.navigator.msSaveOrOpenBlob) {
        let blob = new Blob([decodeURIComponent(encodeURI(data))], {
            type: 'text/csv;charset=utf-8;',
        });
        navigator.msSaveBlob(blob, `${fileName}.csv`);
    } else {
        let a = document.createElement('a');
        a.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(data);
        a.target = '_blank';
        a.download = `${fileName}.csv`;
        document.body.appendChild(a);
        a.click();
    }
}

export function prepareCSVData(columns, data) {
    let csv = '';

    // create header
    columns.forEach(column => {
        csv += `${column.name};`;
    });

    csv += '\r\n';

    // add data
    data.forEach(item => {
        let dataString = '';

        columns.forEach(column => {
            let value = '';
            if (column.value.indexOf('.') > -1) {
                let columns = column.value.split('.');
                value = item[columns[0]][columns[1]];
            } else {
                value = item[column.value];
            }

            value = isNaN(value) && typeof value === 'string' ? value.replace(/(\r\n|\n|\r)/gm, '') : value;
            if (column.action && (value || value === 0)) {
                value = modifyValue(column.action, value, column.translations);
            }
            dataString += `${value ? value : ''};`;
        });

        csv += dataString;
        csv += '\r\n';
    });

    return csv;
}

function modifyValue(action, value, translations) {
    let modifiedValue = value;
    switch (action) {
        case 'uppercase':
            modifiedValue = value.toUpperCase();
            break;
        case 'translate':
            modifiedValue = translations[value];
            break;
        case 'cutdate':
            modifiedValue = value.substring(0, 10);
            break;
    }
    return modifiedValue;
}
